/**
 * Portal Color Configurations
 *
 * Centralized color and gradient definitions for the portal application.
 * These gradients provide a consistent visual theme across all components.
 */

// Core gradient definitions for various UI elements
export const portalGradients = {
  // Navbar gradient - Professional blue with subtle depth
  navbar: 'linear-gradient(135deg, #4C90E9 0%, #2887D0 50%, #1E6DB8 100%)',

  // Avatar gradient - Subtle white background for user avatars
  avatar: 'linear-gradient(135deg, #FFFFFF 0%, #F8FAFE 100%)',

  // Sidebar background - Soft light blue to white gradient
  sidebarBackground: 'linear-gradient(180deg, #F8FAFE 0%, #FFFFFF 10%, #FFFFFF 90%, #F8FAFE 100%)',

  // Selected sidebar item - Highlighted blue background
  sidebarSelected: 'linear-gradient(90deg, rgba(76, 144, 233, 0.15) 0%, rgba(76, 144, 233, 0.08) 100%)',

  // Hover effect for sidebar items
  sidebarHover: 'linear-gradient(90deg, rgba(101, 169, 223, 0.12) 0%, rgba(101, 169, 223, 0.06) 100%)',

  // Footer section of sidebar
  sidebarFooter: 'linear-gradient(180deg, rgba(248, 250, 254, 0.8) 0%, rgba(255, 255, 255, 0.9) 100%)',

  // Expanded footer select background
  sidebarFooterExpanded: 'linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(248, 250, 254, 0.98) 100%)',

  // Card backgrounds - Subtle gradients for content cards
  cardBackground: 'linear-gradient(135deg, #FFFFFF 0%, #FAFBFF 100%)',
  cardHeaderBackground: 'linear-gradient(135deg, #F8FAFE 0%, #FFFFFF 100%)',

  // Button gradients
  primaryButton: 'linear-gradient(135deg, #4C90E9 0%, #2887D0 100%)',
  secondaryButton: 'linear-gradient(135deg, #F8FAFE 0%, #E8F2FE 100%)',

  // Status gradients for different states
  successGradient: 'linear-gradient(135deg, #10B981 0%, #059669 100%)',
  warningGradient: 'linear-gradient(135deg, #F59E0B 0%, #D97706 100%)',
  errorGradient: 'linear-gradient(135deg, #EF4444 0%, #DC2626 100%)',
  infoGradient: 'linear-gradient(135deg, #3B82F6 0%, #2563EB 100%)',

  // Background overlays
  modalOverlay: 'linear-gradient(135deg, rgba(76, 144, 233, 0.1) 0%, rgba(40, 135, 208, 0.15) 100%)',
  pageBackground: 'linear-gradient(180deg, #FAFBFF 0%, #FFFFFF 50%, #F8FAFE 100%)'
}

// Individual color palette for custom styling
export const portalColors = {
  // Primary color scheme
  primary: {
    50: '#F0F7FF',
    100: '#E0EFFF',
    200: '#B8DFFF',
    300: '#7CC7FF',
    400: '#36ABFF',
    500: '#4C90E9',
    600: '#2887D0',
    700: '#1E6DB8',
    800: '#1A5A9B',
    900: '#1A4A7D'
  },

  // Secondary blue tones
  secondary: {
    50: '#F8FAFE',
    100: '#E8F2FE',
    200: '#D1E7FD',
    300: '#AAD4FB',
    400: '#7CB8F7',
    500: '#65A9DF',
    600: '#4A8BC8',
    700: '#3A71A6',
    800: '#2E5A89',
    900: '#1F3D5C'
  },

  // Neutral grays
  neutral: {
    50: '#F9FAFB',
    100: '#F3F4F6',
    200: '#E5E7EB',
    300: '#D1D5DB',
    400: '#9CA3AF',
    500: '#6B7280',
    600: '#4B5563',
    700: '#374151',
    800: '#1F2937',
    900: '#111827'
  },

  // Status colors
  success: '#10B981',
  warning: '#F59E0B',
  error: '#EF4444',
  info: '#3B82F6'
}
